<template>
	<div id="d21-services">
		<div class="mdl-grid">
			<Address v-if="Channel.Address" id="d21-services-header" />
		</div>
		<div v-if="result && !isDateSelection">
			<div class="d21-block" v-if="selectedDepartment === null">
				<div class="mdl-grid">
					<label class="text-header">
						<i>&nbsp;</i>{{ T("Which_department") }}
					</label>
					<div class="d21-product-item mdl-cell mdl-cell--12-col" v-for="department in result" :key="department._uuid" @click="selectDepartment(department)">
						{{ V(department, "Content.Name") }}
						<i class="material-icons">chevron_right</i>
						<span class="d21-department-address" v-if="department.Address.AddressLine1 !== null">
							{{ department.Address.PostalCode }} {{ department.Address.City }},
							{{ department.Address.AddressLine1 }}
						</span>
					</div>
				</div>
			</div>
			<div class="d21-block" v-else>
				<div class="mdl-grid">
					<label class="text-header">
						<i v-if="!isDefault" class="material-icons" @click="unselectDepartment()">chevron_left</i>
						<div class="text-header-aligned">
							{{ T("Which_services") }}
							<div class="filtering-bar">
								<input type="text" ref="servicesFiltering" v-model="filteringInput"  spellcheck="false" autocorrect="off" autocomplete="off" :placeholder="T('search')">
								<i class="material-icons" @click="$refs.servicesFiltering.focus();">search</i>
							</div>
						</div>
					</label>
					<ServiceProduct v-for="service in filteredServices" :service="service" :showSums="showSums" class="mdl-cell mdl-cell--12-col" :key="service._uuid" @selected="onServiceSelected" />
				</div>
			</div>
		</div>

		<div id="d21-services-date" v-if="isDateSelection">
			<div class="d21-block">
				<div class="mdl-grid">
					<label class="text-header">
						<i class="material-icons" @click="isDateSelection = false">chevron_left</i>
						{{ T("When_would_you_like_the_appointment") }}
					</label>
					<div class="mdl-cell mdl-cell--4-col mdl-cell--12-col-m">
						<Datepicker id="date-from" v-model="selectedCalendarDate" :inline="true" :disabled-dates="disabledDays" :noClearButton="true" :no-label="true" :no-button-now="true" :range="false" :min-date="new Date().toISOString()" :only-date="true" :no-header="false" :no-shortcuts="true" :color="'#006bb7'" :formatted="'ll'" :output-format="'YYYY-MM-DD'" :auto-close="true" />
						<!-- Product Hints -->
						<template v-for="service in services">
							<div :key="service.Content.Name" v-if="service.Content.Hint" class="d21-product-hint">
								<label class="d21-product-name">
									<i class="material-icons">info_outline</i>
									{{ service.Content.Name }} :
								</label>
								<span class="d21-product-hintText" v-html="service.Content.Hint"></span>
							</div>
						</template>
					</div>
					<div class="mdl-cell mdl-cell--8-col mdl-cell--12-col-m">
						<Loader />
						<TickList v-if="tickGroups.length" :tickGroups="tickGroups" @select="selectTick" />
						<div v-else-if="!isLoading" class="flex-center">
							<i class="material-icons mr-05">info_outline</i>
							<span>{{ T("services_no_availability") }}</span>
						</div>
					</div>
				</div>
			</div>
		</div>

		<BottomNav @next="next" :isNextButtonActive="isButtonActive" :hiddenText="buttonHiddenText" :shownText="buttonShownText" :isValid="isValid">
			<template v-if="showResult">
				<div class="d21-sum">
					<template v-if="showSums && totalDuration > 0">
						{{ formattedDuration }} | {{ formatPrice(totalSum, Channel) }}
					</template>
					<template v-else-if="totalDuration > 0">
						{{ formattedDuration }}
					</template>
				</div>
			</template>
		</BottomNav>
	</div>
</template>
<script>
	import moment from "moment";
	import Datepicker from "vue-ctk-date-time-picker";
	import baseMixin from "../mixins/base";
	import BottomNav from "./ui/bottom-nav.vue";
	import Address from "./partial/address.vue";
	import TickList from "./partial/tick-list.vue";
	import ServiceProduct from "./partial/service-product.vue";
	import Loader from "./ui/loader.vue";
	import helpers from "../scripts/_helpers";
	import {
		EventBus
	} from "../scripts/_eventBus";
	import {
		mapActions
	} from "vuex";

	const INDEXED_WEEKDAYS = {
		0: "Sunday",
		1: "Monday",
		2: "Tuesday",
		3: "Wednesday",
		4: "Thursday",
		5: "Friday",
		6: "Saturday",
	};

	export default {
		name: "d21-departments",
		mixins: [baseMixin],
		components: {
			Datepicker,
			BottomNav,
			Address,
			TickList,
			ServiceProduct,
			Loader,
		},
		computed: {
			isValid() {
				return (
					(!this.isDateSelection &&
						this.selectedDepartment !== null &&
						this.selectedDepartment.Services.filter((s) => s.Count > 0).length >
						0) ||
					(this.isDateSelection && this.selectedDate !== null)
				);
			},
			formattedDuration() {
				let output = "";
				if (this.totalDuration <= 0) return " 0 min ";
				if (this.getTotalDays() > 0) output += this.getTotalDays() + " d ";
				if (this.getTotalPartialHours() > 0)
					output += this.getTotalPartialHours() + " h ";
				if (this.getTotalPartialMinutes() > 0)
					output += this.getTotalPartialMinutes() + " min ";
				return output;
			},
			totalDuration() {
				let duration = 0;
				if (this.selectedDepartment === null) return duration;
				this.selectedDepartment.Services.forEach((s) => {
					if (s.Count > 0) duration += s.Count * s.Duration;
				});
				return duration;
			},
			totalSum() {
				let total = 0;
				if (this.selectedDepartment === null) return total;
				this.selectedDepartment.Services.forEach((s) => {
					if (s.Count > 0) total += s.Count * s.Total;
				});
				return total;
			},
			showSums() {
				return this.totalSum > 0 || this.Channel._oid !== 123748;
			},
			filteredServices(){
				if (this.selectedDepartment == null) return [];
				return this.filteringInput != "" ? 
					this.selectedDepartment.Services.filter(s => s.Content.Name.toLowerCase().includes(this.filteringInput.trim().toLowerCase())) : 
					this.selectedDepartment.Services;
			},
			services() {
				if (this.selectedDepartment == null) return [];
				return this.selectedDepartment.Services.filter((s) => s.Count > 0);
			},
			isButtonActive() {
				return (
					(this.isDateSelection || (this.result && !this.isDateSelection)) &&
					this.selectedDepartment !== null
				);
			},
			buttonHiddenText() {
				if (this.result && !this.isDateSelection) {
					return this.T("forward_to_appointment_selection");
				} else if (this.isDateSelection) {
					return this.T("forward_to_data_input");
				}
				return this.buttonShownText;
			},
			buttonShownText() {
				return this.T("proceed");
			},
			selectedServices() {
				return this.selectedDepartment.Services.filter((s) => s.Count > 0);
			},
			showResult() {
				return this.result && this.selectedDepartment !== null;
			},
			disabledDays() {
				return this.disabledDates;
			}
		},
		data() {
			return {
				isDateSelection: false,
				tickGroups: [],
				selectedCalendarDate: moment(),
				selectedCalendarTick: null,
				selectedDate: null,
				selectedDepartment: null,
				result: null,
				isDefault: false,
				isLoading: false,
				tickRequest: null,
				availableDays: [],
				disabledDates: [],
				prelaodingDays: {
					isLoading: false,
					startDate: null,
					endDate: null
				},
				filteringInput: ""
			};
		},
		mounted() {
			moment.locale("de-DE");
			EventBus.$on("loading_start", () => (this.isLoading = true));
			EventBus.$on("loading_end", () => (this.isLoading = false));
			this.loadServices();
		},
		methods: {
			...mapActions(["validateReservation"]),
			isDateBetween(date, from, until) {
				return (
					from.getTime() - date.getTime() < 0 &&
					until.getTime() - date.getTime() > 0
				);
			},
			getNextDays(amountDays, selectedDate) {
				const now = new Date();
				const date = selectedDate ? new Date(selectedDate) : new Date(now);
				const targetDate = new Date(date);
				targetDate.setDate(targetDate.getDate() + amountDays);

				const days = [];
				while (date.getTime() < targetDate.getTime()) {
					days.push(new Date(date));
					date.setDate(date.getDate() + 1);
				}
				return days;
			},
			preselectFirstDate(days, invalidDays) {
				//find the first available Date which is not invalid and preselect it
				var filtered = moment(
					days.find(
						(d) => !invalidDays.some((i) => i == d.toISOString().split("T")[0])
					)
				);
				var fallback =
					moment().startOf("day").weekday() == 5 ?
					moment().startOf("day").add(2, "days") :
					moment().startOf("day").weekday() == 6 ?
					moment().startOf("day").add(1, "days") :
					moment().startOf("day");

				this.selectedCalendarDate = filtered.isValid() ? filtered : fallback;
			},
			onServiceSelected() {
				// linked clerks of selected services
				var selectedServiceClerks = this.selectedDepartment.Services.filter(
					(s) => s.Count > 0
				).map((s) => {
					if (s.Clerks) return s.Clerks.map((c) => c._uuid);
				});
				// get only common clerks of selected services
				if (selectedServiceClerks.length > 0) {
					selectedServiceClerks = selectedServiceClerks.reduce((a, b) =>
						a.filter((c) => b.includes(c))
					);
				}
				// disabled other services which doesnt have same clerks with selected services
				this.selectedDepartment.Services.forEach((s) => {
					//
					if (selectedServiceClerks.length == 0) {
						s.isDisabled = false;
					} else {
						s.isDisabled =
							s.Clerks &&
							!s.Clerks.some((c) => selectedServiceClerks.includes(c._uuid));
					}
				});
			},
			getTotalPartialMinutes() {
				return this.totalDuration % 60;
			},
			getTotalPartialHours() {
				return Math.floor(this.totalDuration / 60) % 24;
			},
			getTotalDays() {
				return Math.floor(this.totalDuration / 1440);
			},
			selectDepartment(department) {
				this.selectedDepartment = department;

				helpers.fn.pushWindowHistoryState(
					this.toUrlFriendlyString(department.Content.Name)
				);
			},
			selectTick(tick) {
				if (!tick.IsAvailable) return;
				if (!tick.IsEnabled) return;
				if (this.selectedCalendarTick !== null)
					this.selectedCalendarTick.IsSelected = false;
				this.selectedCalendarTick = tick;
				this.selectedCalendarTick.IsSelected = true;
				this.selectedDate = moment(this.selectedCalendarDate)
					.startOf("day")
					.add(tick.Value, "minutes");
			},
			unselectDepartment() {
				this.filteringInput = "";
				this.selectedDepartment = null;

				helpers.fn.clearLastURLUpdate();
			},
			toUrlFriendlyString(url) {
				return url
					.toString()
					.normalize("NFD")
					.replace(/[\u0300-\u036f]/g, "")
					.replace(/\s+/g, "-")
					.toLowerCase()
					.replace(/&/g, "-and-")
					.replace(/[^a-z0-9-]/g, "")
					.replace(/-+/g, "-")
					.replace(/^-*/, "")
					.replace(/-*$/, "");
			},
			loadServices() {
				const productType =
					this.Channel.Mode === "TimeSlots" ? "TimeSlotProduct" : "Service&?productsVersionCode=display_name";
				const command = `/settings/${productType}`;
				this.apiRequest(command, null, "GET", (response) => {
					if (response.Value) {
						response.Value.forEach((d) => {
							d.Services.forEach((s) => {
								s.showDescription = false;
								s.isDisabled = false;
							});
						});
						this.result = response.Value;

						// if we have default department this will be selected immediately (for timeslots)
						if (this.result.length === 1 && this.result[0].IsDefault) {
							this.isDefault = true;
							this.selectDepartment(this.result[0]);
						}

						if (this.Channel.DepartmentOrProduct) {
							var predicate = (x) =>
								this.toUrlFriendlyString(x.Content.Name) ==
								this.Channel.DepartmentOrProduct;
							var serviceToSelect;
							var departmentToSelect;

							if (
								this.result.filter(predicate) &&
								this.result.filter(predicate).length > 0
							) {
								departmentToSelect = this.result.filter(predicate)[0];
							} else {
								var departmentIndex;
								for (var i = 0; i < this.result.length; i++) {
									// TODO:
									if (
										this.result[i].Services.filter(predicate) &&
										this.result[i].Services.filter(predicate).length > 0
									) {
										departmentToSelect = this.result[i];
										departmentIndex = i;

										serviceToSelect =
											this.result[departmentIndex].Services.filter(predicate);
										serviceToSelect[0].Count = 1;
										break;
									}
								}
							}

							if (departmentToSelect) {
								this.selectDepartment(departmentToSelect);
							}
							if (serviceToSelect) {
								this.next();
							}
						}
					}
				});
			},
			filterDays() {
				// at least one shift is infinite and for all weekdays, so we don't have to disable anything.
				this.disabledDates = [];
				if (
					this.Channel.Shifts.some(
						(c) => c.Period.IsInfinite === true && c.Period.DaysOfWeek === null
					)
				)
					return [];

				// sadly the datepicker component doesn't emit the month-changed event, so we need to pre-build the invalid days.
				// This will build 365 days starting from today.
				const days = this.getNextDays(365);

				// go day by day for each day in the selected month
				for (let day of days) {
					// check if day is valid for any shift
					// - Period is infinite or current day is within period
					// AND
					// - All Weekdays or day is that weekday
					const isValid =
						this.Channel.Shifts.some(
							(c) =>
							// valid period
							(c.Period.IsInfinite === true ||
								this.isDateBetween(
									day,
									new Date(c.Period.From),
									new Date(c.Period.Until)
								)) &&
							// valid weekdays
							(c.Period.DaysOfWeek === null ||
								c.Period.DaysOfWeek.includes(INDEXED_WEEKDAYS[day.getDay()]))
						);

					if (!isValid) {
						this.disabledDates.push(moment(day).format("YYYY-MM-DD"));
					}
				}
				this.preselectFirstDate(days, this.disabledDates);
			},
			loadTicks(date) {
				const products = this.services.map((s) => ({
					Item1: s._uuid,
					Item2: s.Count,
				}));
				const command = `/availability/ticks`;
				this.tickGroups = [];
				EventBus.$emit("loading_start");

				this.apiRequest(
					command, {
						Date: date.format("YYYY-MM-DD"),
						Products: products,
					},
					"POST",
					(response) => {
						if (response.Value)
							this.tickGroups = response.Value.Groups.some((g) => g.Ticks.length) ?
							response.Value.Groups : [];
						EventBus.$emit("loading_end");
						this.tickRequest = null;
					},
					null, {
						before: (request) => {
							if (this.tickRequest) this.tickRequest.abort();
							this.tickRequest = request;
						},
					}
				);
			},
			async preloadDates(selectedDate) {
				var self = this;
				var days = this.getNextDays(30, selectedDate);

				this.prelaodingDays = {
					isLoading: true,
					startDate: days[0],
					endDate: days[days.length - 1],
				}

				const products = this.services.map((s) => ({
					Item1: s._uuid,
					Item2: s.Count,
				}));

				var blockedDays = [];
				var promises = [];

				const command = `/availability/ticks`;
				//preload all days and save blocked/available days
				for (let i = 0; i < days.length; i++) {
					promises.push(new Promise((resolve, reject) => {
						this.apiRequest(
							command, {
								Date: moment(days[i]).format("YYYY-MM-DD"),
								Products: products
							},
							"POST",
							response => {
								resolve(response);
							}, null, null);
					}).then((response) => {
						var groups = response.Value.Groups.some(g => g.Ticks.length) ? response.Value.Groups : [];
						if (groups.length) {
							var isValid = groups.some(g => g.Ticks.some(t => t.IsAvailable));

							if (isValid) {
								self.availableDays.push({
									day: moment(groups[0].Ticks[0].Tick).format("YYYY-MM-DD"),
									ticks: groups,
								});
							} else {
								//if no availability disable it
								blockedDays.push(moment(groups[0].Ticks[0].Tick).format("YYYY-MM-DD"));
							}
						} else {
							//If Ticks is empty try disable it by period
							blockedDays.push(moment(days[i]).format("YYYY-MM-DD"));
						}
					}));
				}

				//after it finished loading, fill disabledDates with blocked days.
				//this is mainly for UI-desing as without it "randomly" disables dates.
				Promise.allSettled(promises).then(() => {
					this.disabledDates = this.disabledDates.concat(blockedDays);

					self.prelaodingDays = {
						isLoading: false,
						endDate: null,
					}
				});
			},
			writeDataIntoReservation() {
				// general stuff
				this.Reservation.Payment.Method = this.Channel.Payment.Methods[0];
				this.Reservation._oid = this.Channel._oid;
				this.Reservation.Mode = "Services";

				// date stuff
				var startTime = moment()
					.startOf("day")
					.add(this.selectedCalendarTick.Value, "minute");
				var endTime = moment(startTime).add(this.totalDuration, "minute");
				this.Reservation.Query.From.Date = this.selectedCalendarDate;
				this.Reservation.Query.From.Hour = startTime.get("hour");
				this.Reservation.Query.From.Minute = startTime.get("minute");
				this.Reservation.Query.From.Minutes = this.selectedCalendarTick.Value;
				this.Reservation.Query.Until.Date = this.selectedCalendarDate;
				this.Reservation.Query.Until.Hour = endTime.get("hour");
				this.Reservation.Query.Until.Minute = endTime.get("minute");
				this.Reservation.Query.Until.Minutes =
					this.selectedCalendarTick.Value + this.totalDuration;
				this.Reservation.From = {
					Date: this.selectedCalendarDate.format("YYYY-MM-DD"),
					TimeFrame: {
						Times: {
							Start: this.selectedCalendarTick.Value,
							End: this.selectedCalendarTick.Value + this.totalDuration,
						},
					},
				};

				// products stuff
				this.Reservation.Products = [];
				this.Reservation.Info = {
					Products: [],
				};
				this.selectedDepartment.Services.filter((s) => s.Count > 0).forEach(
					(s) => {
						//
						this.Reservation.Info.Products.push(s);

						//
						Array(s.Count)
							.fill(0)
							.forEach(() => {
								this.Reservation.Products.push({
									_RepositoryName: "Entity.Ticketing.Product",
									_id: s._uuid,
									_uuid: s._uuid,
									Product: s._uuid,
									Count: 1,
									Name: s.Content.Name,
									Units: [],
									Documents: s.Documents ?
										s.Documents.map((d) => {
											return {
												_uuid: null,
												Content: d.Content,
												URI: d.URI,
											};
										}) : [],
									Selling: {
										Count: 1,
										NumberOfPersons: null,
										Price: s.Total,
										VAT: null,
										Duration: s.Duration,
									},
									Tariffs: [{
										Count: 1,
										Total: s.Total,
										Occupancy: [{
											Person: {
												Address: null,
												City: null,
												Communication: {
													Email: null,
												},
												DateOfBirth: null,
												Givenname: null,
												Lastname: null,
												PostalCode: null,
											},
										}, ],
										Tariff: "00000000-0000-0000-0000-000000000000",
										Units: [],
									}, ],
								});
							});
					}
				);
			},
			next() {
				if (this.isDateSelection) {
					this.writeDataIntoReservation();
					this.validateReservation();

					this.$router.push({
						name: "checkout",
					});
				} else {
					// select today or next weekday possible
					this.tickGroups = [];

					this.isDateSelection = true;
				}
			},
		},
		watch: {
			selectedCalendarDate() {
				//was day already loaded?
				if (this.availableDays.length && this.availableDays.some((d) => d.day === this.selectedCalendarDate)) {
					this.tickGroups = this.availableDays.find(
						(a) => a.day === this.selectedCalendarDate
					).ticks;
					EventBus.$emit("loading_end");
				}
				//if day wasnt loaded yet load it
				else {
					this.loadTicks(this.selectedCalendarDate);
					// check if preloading is already active for that date so it wont load days multiple times
					if (!this.prelaodingDays.isLoading || (this.prelaodingDays.startDate < this.selectedCalendarDate && this.prelaodingDays.endDate > this.selectedCalendarDate)) {
						this.preloadDates(this.selectedCalendarDate);
					}
				}
			},
			isDateSelection(val) {
				if (val) {
					this.filterDays();
					//load current date
					this.loadTicks(this.selectedCalendarDate);
					if (!this.prelaodingDays.isLoading || (this.prelaodingDays.startDate < this.selectedCalendarDate && this.prelaodingDays.endDate > this.selectedCalendarDate)) {
						this.preloadDates(this.selectedCalendarDate);
					}
				} else {
					this.availableDays.length = 0;
				}
			}
		},
	};
</script>